import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base.service';
import { Configuracion } from '../models/configuracion.model';
import { Observable } from 'rxjs';
import { FilterExpression, FilterValue } from '../../models/lookup.filter.data';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService extends BaseService<Configuracion> {

  constructor(protected http: HttpClient) {
    super(http);
    this.options = { route : 'configuracion' };
  }

  getConfiguracionsEscuela(escuelaId): Observable<Configuracion[]> {
    const filter = new FilterExpression('AND',
      [new FilterValue('escuelaId', 'Equal', [ escuelaId ])],
      null
    );
    return super.getFileredList(filter);
  }
}
